




















import Vue from 'vue'
import MyFooter from '@/components/MyFooter.vue'

/**
 * Page container.
 *
 * @remarks
 * Shows the menu, the footer and the content of the current page.
 */
export default Vue.extend({
  name: 'App',
  methods: {
    /**
     * State of the path.
     *
     * @remarks
     * Determines if the `path` is the name of the current route
     *
     * @param path - The name of the route to be checked
     * @returns True if the `path` is the name of the current route
     */
    isActive (path: string): boolean {
      return (this.$route.name === path)
    }
  },
  components: {
    MyFooter
  }
})
